
      const url = 'https://blurbcore-test.builder.blurb.com/api/auth/cf-login';

      const searchParams = new URLSearchParams(window.location.search);
      const redirectUrl =
        searchParams.get('redirect') ?? window.location.origin;
      const check = searchParams.get('check');

      const $form = document.getElementById('cf-login-form');
      const $button = $form.querySelector('button[type="submit"]');
      const $vpcAccess = document.getElementById('vpc-access');

      function setCookieAndRedirect(data) {
        const date = new Date();
        date.setTime(date.getTime() + data.cookieExpirationInSeconds * 1000);

        document.cookie = `${data.cookieKey}=${data.cookieValue};expires=${date.toUTCString()}domain=${
          window.location.host
        };path=/`;
        window.location.replace(redirectUrl);
      }

      $form.addEventListener('submit', async (e) => {
        e.preventDefault();

        $button.dataset.loading = 'true';
        const formData = new FormData(e.target);

        await fetch(url, {
          body: JSON.stringify({
            email: formData.get('email'),
            password: formData.get('password'),
          }),
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(async (response) => {
            if (response.ok) {
              return response.json();
            }

            const error = await response.json();
            throw new Error(error?.detail ?? 'Unknown Error');
          })
          .then(setCookieAndRedirect)
          .catch((error) => {
            console.error(error);
            document.documentElement.style.setProperty(
              '--color',
              'var(--error)',
            );
            document.getElementById('error').innerText =
              `Error: ${error.message}`;
          });

        $button.dataset.loading = 'false';
      });

      (async () => {
        if (check) {
          $vpcAccess.style.display = 'flex';
          await fetch(check)
            .then(async (response) => {
              if (response.ok) {
                return response.json();
              }

              const error = await response.json();
              throw new Error(error?.detail ?? 'Unknown Error');
            })
            .then(setCookieAndRedirect)
            .catch((error) => console.error(error));
        }

        $vpcAccess.style.display = 'none';
      })();
    